import { deleteFiles, updateFile, uploadFiles } from "@directus/sdk";
import { directus } from "./directus";
import { saveElements, updateElement } from "./utils";

export const removeFiles = async (files: string[]) => {
  await directus.request(deleteFiles(files));
};
export const uploadFile = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  const result = await directus.request(uploadFiles(formData));
  if (!result) return [];
  return Array.isArray(result) ? result : [result];
};

export const splitNameExt = (filename: string) => {
  const lastDot = filename.lastIndexOf(".");
  if (lastDot <= 0 || lastDot === filename.length - 1) return { name: filename, extension: "bin" };
  return { name: filename.slice(0, lastDot), extension: filename.slice(lastDot + 1).toLowerCase() };
};

export const toggleDeleteFile = (
  doc: any,
  workingDocs: any[],
  toDelete: Set<string>
): { nextDocs: any[]; nextToDelete: Set<string> } => {
  if (doc.file instanceof File) {
    const nextDocs = workingDocs.filter((d: any) => d.clientId !== doc.clientId);
    return { nextDocs, nextToDelete: new Set(toDelete) };
  }
  const key = String(doc.file ?? "");
  const nextToDelete = new Set(toDelete);
  if (nextToDelete.has(key)) nextToDelete.delete(key);
  else nextToDelete.add(key);
  return { nextDocs: [...workingDocs], nextToDelete };
};


export const computeFilesPayload = ({
  workingDocs,
  toDelete,
  originalById,
  folderId,
}: {
  workingDocs: any[];
  toDelete: Set<string>;
  originalById: Map<number, any>;
  folderId?: number;
}) => {
  const newFiles = workingDocs.filter(
    (d) => d.file instanceof File && (folderId == null || Number(d.folder) === Number(folderId))
  );
  const deleteArchivos = Array.from(toDelete);

  const renamed: { id: number; newName: string; file: string; extension: string }[] = [];
  for (const d of workingDocs) {
    if (d?.id == null) continue;
    if (folderId != null && Number(d.folder) !== Number(folderId)) continue;

    const orig = originalById.get(Number(d.id));
    if (!orig) continue;

    if (d.name && d.name !== orig.name) {
      renamed.push({ id: Number(d.id), newName: d.name, file: d.file, extension: d.extension});
    }
  }

  const nextState = workingDocs.filter((d) => folderId == null || Number(d.folder) === Number(folderId));

  return { newFiles, deleteArchivos, renamed, nextState };
};


export async function saveDocs({
  newFiles,
  deleteArchivos,
  renamed,
  refetch,
}: {
  newFiles: any[];
  deleteArchivos: string[];
  renamed: Array<{ id: string | number; newName: string; file: string; extension: string }>;
  refetch: () => void;
}) {
  if (deleteArchivos.length > 0){
    await removeFiles(deleteArchivos);
  }
  for (const element in newFiles){
    const res = await uploadFile(newFiles[element].file);
    const first = res?.[0];
    const directusFileId = (first && (first.id ?? (first as any)?.data?.id)) as string | undefined;
    newFiles[element].file = directusFileId;
    newFiles[element].name = newFiles[element].name.split(".")[0];
    await saveElements("file", newFiles[element]);
  }
  

  for (const r of renamed) {
    await updateElement("file", Number(r.id), { name: r.newName });
    if (typeof (r as any).file === "string" ) {
        await directus.request(updateFile((r as any).file, {
              filename_download: `${r.newName}.${(r as any).extension || "bin"}`,
            }));
        }
  }

  refetch();
}

